import { Component, OnDestroy, OnInit } from '@angular/core';

import { NotificationsService } from 'app/layout/components/navbar/navbar-notification/notifications.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Interface
interface notification {
  messages: [];
  systemMessages: [];
  system: Boolean;
}

@Component({
    selector: 'app-navbar-notification',
    templateUrl: './navbar-notification.component.html',
    standalone: false
})
export class NavbarNotificationComponent implements OnInit, OnDestroy {
  // Public
  public notifications: notification;

  //Private
  private _unsubscribeAll: Subject<any>;

  /**
   *
   * @param {NotificationsService} _notificationsService
   */
  constructor(private _notificationsService: NotificationsService) {
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this._notificationsService.onApiDataChange.pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.notifications = res;
    });
  }


  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
